import {
  dimensionPropertyType,
  computedValueTypes,
  customerTier,
  dlColumnKeys,
} from '../constants';

export const getFilterDisplayName = filter => {
  if (filter.displayName) return filter.displayName;

  if (filter.propertyType === dimensionPropertyType.computedValue) {
    switch (filter.property) {
      case 'cancellationDaysSincePurchased': {
        const propertyValue = computedValueTypes.find(
          e => e.key === `${filter.operator}${filter.value}Days`,
        );
        return propertyValue.text;
      }
      default:
        return filter.value;
    }
  }
  if (filter.property === dlColumnKeys.customerTier) {
    const propertyValue = customerTier.find(e => e.key === filter.value);
    return propertyValue.text;
  }
  return filter.value;
};

export const getFilterIcon = filter => {
  if (filter.propertyType === 'dimensionList') return 'BulletedList';
  if (filter.property === 'product') return 'Product';
  return undefined;
};
